import { render, staticRenderFns } from "./veStuLiteraryAwardItemEdit.vue?vue&type=template&id=7696dc46&scoped=true"
import script from "./veStuLiteraryAwardItemEdit.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7696dc46",
  null
  
)

export default component.exports